import { put, call, takeEvery } from 'redux-saga/effects';
import { replace } from 'connected-react-router';
import {
  ROLES_REQUEST,
  RESOURCES_REQUEST,
  ROLE_REQUEST,
  CREATE_ROLE_REQUEST,
  UPDATE_ROLE_REQUEST,
  DELETE_ROLE_REQUEST,
} from './actionTypes';
import {
  rolesSuccess,
  rolesFailure,
  resourcesSuccess,
  resourcesFailure,
  roleSuccess,
  roleFailure,
  createRoleSuccess,
  createRoleFailure,
  updateRoleSuccess,
  updateRoleFailure,
  deleteRoleSuccess,
  deleteRoleFailure,
} from './actions';
import RoleService from '../../services/RoleService';

export function* getRolesTask() {
  try {
    const list = yield call(RoleService.getRoles);
    yield put(rolesSuccess(list));
  } catch (error) {
    yield put(rolesFailure(error));
  }
}

export function* getResourcesTask() {
  try {
    const list = yield call(RoleService.getResources);
    yield put(resourcesSuccess(list));
  } catch (error) {
    yield put(resourcesFailure(error));
  }
}

export function* getRoleTask(action) {
  try {
    const roleId = action.payload;
    const role = yield call(RoleService.getRole, roleId);
    yield put(replace(`/role/${roleId}`));
    yield put(roleSuccess(role));
  } catch (error) {
    yield put(roleFailure(error));
  }
}

export function* createRoleTask(action) {
  try {
    const params = action.payload;
    const role = yield call(RoleService.createRole, params);
    yield put(createRoleSuccess(role));
    yield put(replace(`/role/${role.id}`));
  } catch (error) {
    yield put(createRoleFailure(error));
  }
}

export function* updateRoleTask(action) {
  try {
    const role = action.payload;
    const updatedRole = yield call(RoleService.updateRole, role);
    yield put(updateRoleSuccess(updatedRole));
    yield put(replace('/roles'));
  } catch (error) {
    yield put(updateRoleFailure(error));
  }
}

export function* deleteRoleTask(action) {
  try {
    const roleId = action.payload;
    yield call(RoleService.deleteRole, roleId);
    yield put(deleteRoleSuccess(roleId));
  } catch (error) {
    yield put(deleteRoleFailure(error));
  }
}

export function* rolesSaga() {
  yield takeEvery(ROLES_REQUEST, getRolesTask);
  yield takeEvery(RESOURCES_REQUEST, getResourcesTask);
  yield takeEvery(ROLE_REQUEST, getRoleTask);
  yield takeEvery(CREATE_ROLE_REQUEST, createRoleTask);
  yield takeEvery(UPDATE_ROLE_REQUEST, updateRoleTask);
  yield takeEvery(DELETE_ROLE_REQUEST, deleteRoleTask);
}
